import Api from 'util/Api';
import API from 'constants/api';

export interface PhysicalAttributes {
  weight?: { value?: number; unit?: string };
  dimensions?: {
    height?: number;
    width?: number;
    length?: number;
    unit?: string;
  };
}

export const getPhysicalAttributes = async (
  shipmentId: number,
): Promise<PhysicalAttributes | null> => {
  try {
    const response = await Api.apiAxios.get(
      API.physicalAttributes.byShipmentId(shipmentId),
    );
    if (response.status !== 200) return null;
    return response.data ?? null;
  } catch (error) {
    return null;
  }
};
